
import React from 'react'

type Props = {
    message: string,
    remark?: string,
    handleConfirm: () => void,
    handleCancel: () => void
}

const ConfirmModal = ({message , handleConfirm , handleCancel, remark} : Props) => {
    return (
        <div className="modal show scale-in" role="dialog" tabIndex={-1}>
        {/* modal set to default size, modal-xl will make it bigger, modal-sm will make it smallest*/}
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            {/* .no-liner will remove the bttom line from header*/}
            <div className="modal-header ">
              <div className="modal-header-content__wrapper">
                <h4 className="modal-header-title">Are you sure?</h4>
              </div>
              <div className="modal-header-content__wrapper">
                <button className="btn btn-small primary-action" aria-label="close">✕</button>
              </div>
            </div>
            <div className="modal-body center">
              <img src="/src/assets/images/featured-cover-warning.webp" alt="" srcSet="" className="modal-body-img__wrapper center" />
              {/* <h3>Are you sure?</h3> */}
              <p>{message}</p>
              <div className="body-btn-group__wrapper">
                <button className="btn btn-primary" onClick={()=>handleConfirm()}>Yes</button>
                <button className="btn btn-secondary" onClick={()=>handleCancel()}>No</button>
              </div>
            </div>
            {/* <div class="modal-footer">
                    <button class="btn btn-secondary">Cancel</button>
                    <button class="btn btn-primary">Confirm</button>
                   </div> */}
          </div>
        </div>
      </div>
    )
}

export {ConfirmModal}